const escapeRegExp = (value) => String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const normalizeNameReplacements = (items) =>
    (items || [])
        .map((rule, index) => ({
            find: String(rule?.find ?? '').trim(),
            replace: String(rule?.replace ?? ''),
            index,
        }))
        .filter((rule) => rule.find)
        .sort((a, b) => b.find.length - a.find.length || a.index - b.index);

export const applyNameReplacements = (text, rules) => {
    let result = String(text ?? '');
    if (!result) return result;
    const prepared = Array.isArray(rules) && rules.length && rules[0]?.index != null
        ? rules
        : normalizeNameReplacements(rules);
    if (!prepared.length) return result;
    prepared.forEach(({ find, replace }) => {
        result = result.replace(new RegExp(escapeRegExp(find), 'gi'), replace);
    });
    return result.replace(/\s{2,}/g, ' ').trim();
};

export const productDisplayName = (product, rules) => {
    const article = product?.color?._id || product?.offer_id || '';
    const original = product?.color?.shortName || product?.shortName || product?.name || '';
    const shortened = applyNameReplacements(original, rules);
    return {
        article,
        original,
        shortened,
        label: [article, shortened].filter(Boolean).join(' '),
    };
};
